import { render, staticRenderFns } from "./jielongOrder.vue?vue&type=template&id=17ec4d5a&scoped=true"
import script from "./jielongOrder.vue?vue&type=script&lang=ts"
export * from "./jielongOrder.vue?vue&type=script&lang=ts"
import style0 from "./jielongOrder.vue?vue&type=style&index=0&id=17ec4d5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ec4d5a",
  null
  
)

export default component.exports